<template>
  <section class="margin-15">
    <compFormEdit
      ref="formbase"
      class="margin-layout"
      :formdata="getBase"
      v-model="formData"
    ></compFormEdit>
    <vButtonGroup class="text-right">
      <vButton theme="primary" @click="add">{{
        $t("fbb.headlogistics.next_step", { defaultValue: "下一步" })
      }}</vButton>
      <vButton @click="cancel">{{
        $t("global.common.return", { defaultValue: "返回" })
      }}</vButton>
    </vButtonGroup>
    <vModal
      v-model="modalProps.show"
      :title="modalProps.title"
      :width="modalProps.width"
      :showFooter="false"
    >
      <component
        :is="modalProps.component"
        @on-close="modalProps.show = false"
        v-on="modalProps.on"
        v-bind="modalProps.props"
      ></component>
    </vModal>
    <vLoading size="large" transfer :loading="loading"></vLoading>
  </section>
</template>

<script>
import { HttpAddInboundOrder } from "@/service/inbound";
import compPlanbill from "./planbill";
export default {
  components: {
    compFormEdit: () => import("@components/templates/formedit"),
    compPlanbill,
  },
  data() {
    return {
      formData: {},
      loading: false,
      modalProps: {
        show: false,
      },
    };
  },

  computed: {
    getBase() {
      return [
        {
          label: this.$t("fbb.inbound.storage_number", {
            defaultValue: "入库计划单号",
          }),
          key: "inboundPlanOrderNo",
          props: {
            readonly: true,
            suffix: "search",
          },
          on: {
            "on-icon-click": this.handleModal,
          },
        },
        {
          label: this.$t("global.common.source_number", {
            defaultValue: "来源单号",
          }),
          key: "sourceNo",
          required: false,
        },
        {
          label: this.$t("global.common.warehouse", { defaultValue: "仓库" }),
          key: "orgWarehouseCode",
          query: true,
        },
        {
          label: this.$t("global.common.project", { defaultValue: "项目" }),
          key: "lineName",
          query: true,
        },
        {
          label: this.$t("fbb.headlogistics.container_number", {
            defaultValue: "集装箱号",
          }),
          key: "containerNo",
          query: true,
        },
        {
          label: this.$t("", { defaultValue: "贴标数" }),
          tag: "vInputNumber",
          key: "labelQty",
          required: false,
          props: {
            min: 0,
            math: "floor",
          },
        },
        {
          label: this.$t("global.common.notes", { defaultValue: "备注" }),
          tag: "vTextarea",
          key: "remark",
          required: false,
        },
      ];
    },
  },
  methods: {
    add() {
      const {
        sourceNo,
        id: inboundPlanOrderId,
        remark,
        labelQty,
      } = this.formData;
      if (!inboundPlanOrderId) {
        return this.$VMessage.warning(
          this.$t("fbb.inbound.order_inbound_no_not_null", {
            defaultValue: "入库计划单号不能为空",
          })
        );
      }
      this.loading = true;
      HttpAddInboundOrder({
        inboundPlanOrderId,
        sourceNo,
        labelQty,
        remark,
      })
        .then((res) => {
          this.$router.push({
            name: "inboundOrderDetail",
            params: {
              type: "edit",
            },
            query: {
              id: res.data.id,
            },
          });
        })
        .catch((err) => {
          this.loading = false;
          this.$VMessage.error(err.message);
        });
    },
    // 详情操作
    handleModal() {
      this.modalProps = {
        show: true,
        width: 1000,
        title: this.$t("fbb.inbound.order_find_inbound_plan", {
          defaultValue: "查找入库计划",
        }),
        component: "compPlanbill",
        props: {
          startUp: true,
        },
        on: {
          "on-data": (row) => {
            this.formData = row;
            this.formData.sourceNo = "";
            this.formData.remark = "";
            this.formData.containerNo = [
              row.gpCartonNo20,
              row.gpCartonNo40,
              row.hqCartonNo40,
              row.hqCartonNo45,
            ]
              .filter((val) => !!val)
              .join(",");
            this.modalProps = {};
          },
        },
      };
    },
    cancel() {
      this.$emit("on-close");
    },
  },
};
</script>
